var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"staticBar rounded"},[_c('div',{staticClass:"dinamicBar rounded",style:({ 'width': (_vm.secureData + "%") })})])])}
var staticRenderFns = []

export { render, staticRenderFns }